import React from "react";
import TillBasedSource from "../From/TillBasedSource";
import Select from "../../../../form/Select";
import {optionsTemplate} from "../../../../../utils/formatters";

export default (propsTop) => {
    const componentProps = {...propsTop};
    const {props, state, parent} = propsTop;
    const {hidden, labels} = props;
    return (
        <div className="row form-row">
            <div className="col-md-12">
                {!props.user.hasPermission("change_inventory")
                ?
                    <TillBasedSource
                        {...componentProps}
                        visible={true}
                    />
                :
                    <Select
                        label="Raktár"
                        name="source"
                        component="store"
                        isClearable={true}
                        objectValue={true}
                        labelKey="name"
                        storeType="remote"
                        optionsTemplate={optionsTemplate("location")}
                        {...props.getProps("source")}
                        value={props.getValue("source")}
                        saveChanges={props.setFieldValue}
                    />}
            </div>
        </div>
    );
}